"use client";

import Link from "next/link";
import Image from "next/image";

import { Plan } from "@/types";

import { useToast } from "@/components/ui/use-toast";

import Cross from "/public/assets/content/cross.png";
import Edit from "/public/assets/content/edit.svg";
import UrlLink from "/public/assets/content/link.png";

type Props = {
	plan: Plan;
};

export default function PlanButtonHeader({ plan }: Props) {
	const { toast } = useToast();

	const planType = plan.isCustomPlan ? "custom" : "generic";
	const adminPlansBase =
		plan.planType === "hosting"
			? "/admin/content/types/hosting-plans"
			: "/admin/content/types/subscription-plans";

	const onDelete = () => {
		toast({ variant: "destructive", title: "Feature not implemented yet" });
	};

	const onCopyLink = () => {
		navigator.clipboard.writeText(
			`${process.env.NEXT_PUBLIC_FRONTEND_URI}/customplan?slug=${plan.slug}`,
		);

		toast({ title: "Success", description: "Link copied successfully" });
	};

	return (
		<div className="flex h-10 items-center justify-between rounded-t-[20px] bg-[#D9D9D9] px-4">
			<Link href={`${adminPlansBase}/${planType}/${plan._id}`}>
				<Image draggable="false" src={Edit} alt="edit" height={22} width={22} className="object-contain" />
			</Link>

			{plan.isCustomPlan && (
				<button onClick={onCopyLink} className="flex items-center justify-center">
					<Image
						draggable="false"
						src={UrlLink}
						alt="copy"
						height={20}
						width={20}
						className="size-4 object-contain"
					/>
					<span className="ml-3 text-white">Copy link</span>
				</button>
			)}

			<button className="" onClick={onDelete}>
				<Image draggable="false" src={Cross} alt="delete" height={22} width={22} className="object-contain" />
			</button>
		</div>
	);
}
